import { ArrowLeft, ArrowRight, CaretLeft, CaretRight, type IconProps } from "@phosphor-icons/react";
import { getDirection, useStoreLanguage } from "../store-language/i18n.ts";

type DirectionalIconProps = Omit<IconProps, "direction" | "mirrored"> & {
  direction: "back" | "forward";
  variant?: "arrow" | "chevron";
};

/** Logical navigation direction; callers never select or mirror a physical arrow. */
export default function DirectionalIcon({ direction, variant = "arrow", ...props }: DirectionalIconProps) {
  useStoreLanguage();
  // Product convention: Back and forward navigation point toward the inline end.
  const pointsLeft = getDirection() === "rtl";
  const Icon = variant === "chevron"
    ? (pointsLeft ? CaretLeft : CaretRight)
    : (pointsLeft ? ArrowLeft : ArrowRight);

  return (
    <Icon
      data-navigation-direction={direction}
      aria-hidden="true"
      {...props}
    />
  );
}
